import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import "moment/locale/es";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import {
  BarraFiltrosSolicitudes,
  consultarSolicitudes,
  crearFiltrosIniciales,
  useOpcionesFiltros,
} from "./../../components/filtros-solicitudes/filtros-solicitudes.jsx";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-buttons-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

Moment.locale("es");

function CreatChart() {
  const modules = JSON.parse(localStorage.getItem("modulos")) || [];
  const location = useLocation();

  const tabs = [
    { name: "Crear", to: "/deals/request", module: "deals-request" },
    { name: "Solicitudes", to: "/deals/update", module: "deals-update" },
    { name: "Resumen", to: "/deals/requests", module: "deals-requests" },
    { name: "Ranking", to: "/deals/ranking", module: "deals-ranking" },
  ];

  const [mailData, setMailData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processedData, setProcessedData] = useState([]);

  // Filtros homologados (últimos 60 días por default)
  const [filters, setFilters] = useState(crearFiltrosIniciales);
  const { opciones: opcionesFiltros } = useOpcionesFiltros(mailData);

  const tableRef = useRef(null);

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

  const apiUrl = "https://api.checkmark.mx/solicitudes/consultar";

  const normalizarTexto = (valor) => {
    return String(valor || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const normalizarTipoAuto = (value) => {
    const tipo = normalizarTexto(value);

    if (tipo.includes("semi")) return "Seminuevo";
    if (tipo.includes("nuevo")) return "Nuevo";

    return "";
  };

  const calcularPorcentaje = (cantidad, total) => {
    if (Number(total) > 0) {
      return ((Number(cantidad || 0) / Number(total)) * 100).toFixed(1) + "%";
    }

    return "0%";
  };

  const esCreditoSolicitud = (solicitud) => {
    const dependeAuto = normalizarTexto(
      solicitud.depende_auto ?? solicitud.depente_auto,
    );

    // Regla actual:
    // depende_auto = "No" => Crédito
    // depende_auto = "Si" => Contado
    return dependeAuto === "no";
  };

  const esContadoSolicitud = (solicitud) => {
    const dependeAuto = normalizarTexto(
      solicitud.depende_auto ?? solicitud.depente_auto,
    );

    return dependeAuto === "si";
  };

  const esArrendamientoSolicitud = (solicitud) => {
    const dependeAuto = normalizarTexto(
      solicitud.depende_auto ?? solicitud.depente_auto,
    );

    return dependeAuto === "arrendamiento";
  };

  const generarResumenPorAsesor = (resultados) => {
    const agrupados = resultados.reduce((acc, solicitud) => {
      const asesor = solicitud.asesor?.trim() || "Sin asesor";

      if (!acc[asesor]) {
        acc[asesor] = {
          nombre: asesor,

          total: 0,
          totalCredito: 0,
          totalContado: 0,
          totalArrendamiento: 0,

          // Status crédito
          autorizado: 0,
          rechazadoCredito: 0,
          pendienteBuro: 0,

          // Substatus crédito
          analisis: 0,
          incompleto: 0,
          condicionadoViable: 0,
          condicionadoNoViable: 0,
          facturado: 0,
          formalizadoCredito: 0,
          aprobadoSinFormalizar: 0,
          rechazadoSubstatus: 0,

          // Status contado
          cotizacionContado: 0,
          formalizadoContado: 0,

          // Status arrendamiento
          cotizacionArrendamiento: 0,
          pendienteAutorizacionArrendamiento: 0,
          autorizadoArrendamiento: 0,
          rechazadoArrendamiento: 0,
          formalizadoArrendamiento: 0,

          // Totales generales
          formalizadosTotal: 0,
          rechazadosTotal: 0,
        };
      }

      acc[asesor].total += 1;

      const esCredito = esCreditoSolicitud(solicitud);
      const esContado = esContadoSolicitud(solicitud);
      const esArrendamiento = esArrendamientoSolicitud(solicitud);

      const status = normalizarTexto(solicitud.status);
      const subStatus = normalizarTexto(solicitud.sub_status);

      if (esCredito) {
        acc[asesor].totalCredito += 1;

        // Status de crédito
        if (status === "autorizado") {
          acc[asesor].autorizado += 1;
        } else if (status === "rechazado") {
          acc[asesor].rechazadoCredito += 1;
          acc[asesor].rechazadosTotal += 1;
        } else if (status === "pendiente de buro") {
          acc[asesor].pendienteBuro += 1;
        }

        // Substatus de crédito
        if (subStatus === "analisis") {
          acc[asesor].analisis += 1;
        } else if (subStatus === "incompleto") {
          acc[asesor].incompleto += 1;
        } else if (subStatus === "condicionado viable") {
          acc[asesor].condicionadoViable += 1;
        } else if (subStatus === "condicionado no viable") {
          acc[asesor].condicionadoNoViable += 1;
        } else if (subStatus === "facturado") {
          acc[asesor].facturado += 1;
        } else if (subStatus === "formalizado") {
          acc[asesor].formalizadoCredito += 1;
          acc[asesor].formalizadosTotal += 1;
        } else if (subStatus === "aprobado sin formalizar") {
          acc[asesor].aprobadoSinFormalizar += 1;
        } else if (subStatus === "rechazado") {
          acc[asesor].rechazadoSubstatus += 1;
          acc[asesor].rechazadosTotal += 1;
        }
      }

      if (esContado) {
        acc[asesor].totalContado += 1;

        // Status de contado
        if (status === "cotizacion") {
          acc[asesor].cotizacionContado += 1;
        } else if (status === "formalizado") {
          acc[asesor].formalizadoContado += 1;
          acc[asesor].formalizadosTotal += 1;
        }
      }

      if (esArrendamiento) {
        acc[asesor].totalArrendamiento += 1;

        // Status de arrendamiento
        if (status === "cotizacion") {
          acc[asesor].cotizacionArrendamiento += 1;
        } else if (status === "pendiente de autorizacion") {
          acc[asesor].pendienteAutorizacionArrendamiento += 1;
        } else if (status === "autorizado") {
          acc[asesor].autorizadoArrendamiento += 1;
        } else if (status === "rechazado") {
          acc[asesor].rechazadoArrendamiento += 1;
          acc[asesor].rechazadosTotal += 1;
        } else if (status === "formalizado") {
          acc[asesor].formalizadoArrendamiento += 1;
          acc[asesor].formalizadosTotal += 1;
        }
      }

      return acc;
    }, {});

    return Object.values(agrupados);
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      // Todos los filtros (incluido tipo de auto) se aplican en el servidor
      const { statusCode, resultados: resultadosApi } =
        await consultarSolicitudes(filters);

      if (statusCode === 200 && resultadosApi.length > 0) {
        const resultadosFiltrados = resultadosApi;

        const datosProcesados = generarResumenPorAsesor(resultadosFiltrados);

        setMailData(resultadosFiltrados);
        setProcessedData(datosProcesados);
      } else {
        setMailData([]);
        setProcessedData([]);

        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron resultados para los filtros aplicados.",
        });

        console.error(
          "Error: No hay registros disponibles o la respuesta es inválida.",
        );
      }
    } catch (error) {
      setMailData([]);
      setProcessedData([]);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al obtener los datos.",
      });

      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#datatableDefault")) {
      $("#datatableDefault").DataTable().destroy();
    }

    if (!loading && processedData.length > 0) {
      setTimeout(() => {
        if ($("#datatableDefault").length) {
          tableRef.current = $("#datatableDefault").DataTable({
            dom: "<'row mb-3'<'col-md-4'l><'col-md-8 text-right'<'d-lg-flex justify-content-end'fB>>>t<'row align-items-center mt-3'<'mr-auto col-md-6 mb-3 mb-md-0'i><'mb-0 col-md-6'p>>",
            lengthMenu: [10, 20, 30, 40, 50],
            responsive: false,
            scrollX: true,
            autoWidth: false,
            buttons: [
              {
                extend: "print",
                className: "btn btn-default btn-sm ms-2 mt-3 mt-md-0",
              },
              {
                extend: "csv",
                className: "btn btn-default btn-sm mt-3 mt-md-0",
              },
            ],
          });
        }
      }, 100);
    }

    return () => {
      if ($.fn.DataTable.isDataTable("#datatableDefault")) {
        $("#datatableDefault").DataTable().destroy();
      }
    };
  }, [loading, processedData]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }

      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);


  const totales = processedData.reduce(
    (acc, asesor) => {
      acc.totalSolicitudes += asesor.total;
      acc.totalCredito += asesor.totalCredito;
      acc.totalContado += asesor.totalContado;
      acc.totalArrendamiento += asesor.totalArrendamiento;

      acc.totalAutorizadas += asesor.autorizado;
      acc.totalRechazadasCredito += asesor.rechazadoCredito;
      acc.totalPendienteBuro += asesor.pendienteBuro;

      acc.totalAnalisis += asesor.analisis;
      acc.totalIncompleto += asesor.incompleto;
      acc.totalCondicionadoViable += asesor.condicionadoViable;
      acc.totalCondicionadoNoViable += asesor.condicionadoNoViable;
      acc.totalFacturado += asesor.facturado;
      acc.totalFormalizadoCredito += asesor.formalizadoCredito;
      acc.totalAprobadoSinFormalizar += asesor.aprobadoSinFormalizar;
      acc.totalRechazadoSubstatus += asesor.rechazadoSubstatus;

      acc.totalCotizacionContado += asesor.cotizacionContado;
      acc.totalFormalizadoContado += asesor.formalizadoContado;

      acc.totalCotizacionArrendamiento += asesor.cotizacionArrendamiento;
      acc.totalPendienteAutorizacionArrendamiento +=
        asesor.pendienteAutorizacionArrendamiento;
      acc.totalAutorizadoArrendamiento += asesor.autorizadoArrendamiento;
      acc.totalRechazadoArrendamiento += asesor.rechazadoArrendamiento;
      acc.totalFormalizadoArrendamiento += asesor.formalizadoArrendamiento;

      acc.totalFormalizados += asesor.formalizadosTotal;
      acc.totalRechazados += asesor.rechazadosTotal;

      return acc;
    },
    {
      totalSolicitudes: 0,
      totalCredito: 0,
      totalContado: 0,
      totalArrendamiento: 0,

      totalAutorizadas: 0,
      totalRechazadasCredito: 0,
      totalPendienteBuro: 0,

      totalAnalisis: 0,
      totalIncompleto: 0,
      totalCondicionadoViable: 0,
      totalCondicionadoNoViable: 0,
      totalFacturado: 0,
      totalFormalizadoCredito: 0,
      totalAprobadoSinFormalizar: 0,
      totalRechazadoSubstatus: 0,

      totalCotizacionContado: 0,
      totalFormalizadoContado: 0,

      totalCotizacionArrendamiento: 0,
      totalPendienteAutorizacionArrendamiento: 0,
      totalAutorizadoArrendamiento: 0,
      totalRechazadoArrendamiento: 0,
      totalFormalizadoArrendamiento: 0,

      totalFormalizados: 0,
      totalRechazados: 0,
    },
  );

  return (
    <div>
      {loading ? (
        <div className="loader-data">
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div>
          <div className="mailbox">
            <div className="mailbox-toolbar">
              {tabs.map((tab) =>
                modules.includes(tab.module) ? (
                  <div className="mailbox-toolbar-item" key={tab.name}>
                    <Link
                      to={tab.to}
                      className={`mailbox-toolbar-link ${
                        location.pathname === tab.to ? "active" : ""
                      }`}
                    >
                      {tab.name}
                    </Link>
                  </div>
                ) : null,
              )}
            </div>

            <div className="mailbox-body" style={{ display: "block" }}>
              <div className="row">
                <div className="col-12">
                  <div className="mailbox-content">
                    <div className="mailbox-detail">
                      <h1 className="page-header">
                        Gráficas{" "}
                        <small>
                          estadísticas, descripción general y rendimiento
                        </small>
                      </h1>

                      <BarraFiltrosSolicitudes
                        filters={filters}
                        onChange={setFilters}
                        opciones={opcionesFiltros}
                      />

                      <style>
                        {`
                          .ranking-status-table th,
                          .ranking-status-table td {
                            white-space: nowrap;
                            padding: 10px 18px !important;
                            vertical-align: middle;
                          }

                          .ranking-status-table th {
                            padding-right: 35px !important;
                            position: relative;
                          }

                          table.dataTable thead > tr > th.sorting,
                          table.dataTable thead > tr > th.sorting_asc,
                          table.dataTable thead > tr > th.sorting_desc {
                            padding-right: 35px !important;
                          }

                          table.dataTable thead > tr > th.sorting::before,
                          table.dataTable thead > tr > th.sorting::after,
                          table.dataTable thead > tr > th.sorting_asc::before,
                          table.dataTable thead > tr > th.sorting_asc::after,
                          table.dataTable thead > tr > th.sorting_desc::before,
                          table.dataTable thead > tr > th.sorting_desc::after {
                            right: 12px !important;
                          }

                          .ranking-status-table th:nth-child(1),
                          .ranking-status-table td:nth-child(1) {
                            min-width: 180px;
                          }
                        `}
                      </style>

                      {processedData.length > 0 ? (
                        <table
                          id="datatableDefault"
                          className="table table-bordered align-middle w-100 ranking-status-table"
                        >
                          <thead>
                            <tr>
                              <th>Asesor</th>
                              <th>Total</th>

                              <th>Crédito</th>
                              <th>% Crédito</th>
                              <th>Contado</th>
                              <th>% Contado</th>
                              <th>Arrendamiento</th>
                              <th>% Arrendamiento</th>

                              <th>Autorizado</th>
                              <th>% Autorizado</th>
                              <th>Rechazado Crédito</th>
                              <th>% Rechazado Crédito</th>
                              <th>Pendiente Buró</th>
                              <th>% Pendiente Buró</th>

                              <th>Análisis</th>
                              <th>Incompleto</th>
                              <th>Cond. Viable</th>
                              <th>Cond. No Viable</th>
                              <th>Facturado</th>
                              <th>Formalizado Crédito</th>
                              <th>Aprobado Sin Formalizar</th>
                              <th>Rechazado Substatus</th>

                              <th>Cotización Contado</th>
                              <th>Formalizado Contado</th>

                              <th>Cotización Arrendamiento</th>
                              <th>Pendiente Autorización Arrendamiento</th>
                              <th>Autorizado Arrendamiento</th>
                              <th>% Autorizado Arrendamiento</th>
                              <th>Rechazado Arrendamiento</th>
                              <th>% Rechazado Arrendamiento</th>
                              <th>Formalizado Arrendamiento</th>

                              <th>Total Formalizados</th>
                              <th>% Formalizados</th>
                              <th>Total Rechazados</th>
                              <th>% Rechazados</th>
                            </tr>
                          </thead>

                          <tbody>
                            {processedData.map((asesor) => (
                              <tr key={asesor.nombre}>
                                <td className="black-text">{asesor.nombre}</td>

                                <td className="black-text">{asesor.total}</td>

                                <td>{asesor.totalCredito}</td>
                                <td>
                                  {calcularPorcentaje(
                                    asesor.totalCredito,
                                    asesor.total,
                                  )}
                                </td>

                                <td>{asesor.totalContado}</td>
                                <td>
                                  {calcularPorcentaje(
                                    asesor.totalContado,
                                    asesor.total,
                                  )}
                                </td>

                                <td>{asesor.totalArrendamiento}</td>
                                <td>
                                  {calcularPorcentaje(
                                    asesor.totalArrendamiento,
                                    asesor.total,
                                  )}
                                </td>

                                <td className="text-green">
                                  {asesor.autorizado}
                                </td>
                                <td className="text-green">
                                  {calcularPorcentaje(
                                    asesor.autorizado,
                                    asesor.totalCredito,
                                  )}
                                </td>

                                <td className="text-red">
                                  {asesor.rechazadoCredito}
                                </td>
                                <td className="text-red">
                                  {calcularPorcentaje(
                                    asesor.rechazadoCredito,
                                    asesor.totalCredito,
                                  )}
                                </td>

                                <td className="text-blue">
                                  {asesor.pendienteBuro}
                                </td>
                                <td className="text-blue">
                                  {calcularPorcentaje(
                                    asesor.pendienteBuro,
                                    asesor.totalCredito,
                                  )}
                                </td>

                                <td>{asesor.analisis}</td>
                                <td>{asesor.incompleto}</td>
                                <td>{asesor.condicionadoViable}</td>
                                <td>{asesor.condicionadoNoViable}</td>
                                <td>{asesor.facturado}</td>
                                <td>{asesor.formalizadoCredito}</td>
                                <td>{asesor.aprobadoSinFormalizar}</td>
                                <td>{asesor.rechazadoSubstatus}</td>

                                <td>{asesor.cotizacionContado}</td>
                                <td>{asesor.formalizadoContado}</td>

                                <td>{asesor.cotizacionArrendamiento}</td>
                                <td>
                                  {
                                    asesor.pendienteAutorizacionArrendamiento
                                  }
                                </td>
                                <td className="text-green">
                                  {asesor.autorizadoArrendamiento}
                                </td>
                                <td className="text-green">
                                  {calcularPorcentaje(
                                    asesor.autorizadoArrendamiento,
                                    asesor.totalArrendamiento,
                                  )}
                                </td>
                                <td className="text-red">
                                  {asesor.rechazadoArrendamiento}
                                </td>
                                <td className="text-red">
                                  {calcularPorcentaje(
                                    asesor.rechazadoArrendamiento,
                                    asesor.totalArrendamiento,
                                  )}
                                </td>
                                <td>{asesor.formalizadoArrendamiento}</td>

                                <td className="text-green">
                                  {asesor.formalizadosTotal}
                                </td>
                                <td className="text-green">
                                  {calcularPorcentaje(
                                    asesor.formalizadosTotal,
                                    asesor.total,
                                  )}
                                </td>

                                <td className="text-red">
                                  {asesor.rechazadosTotal}
                                </td>
                                <td className="text-red">
                                  {calcularPorcentaje(
                                    asesor.rechazadosTotal,
                                    asesor.total,
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>

                          <tfoot>
                            <tr style={{ fontWeight: "bold" }}>
                              <td>Total</td>
                              <td>{totales.totalSolicitudes}</td>

                              <td>{totales.totalCredito}</td>
                              <td>
                                {calcularPorcentaje(
                                  totales.totalCredito,
                                  totales.totalSolicitudes,
                                )}
                              </td>

                              <td>{totales.totalContado}</td>
                              <td>
                                {calcularPorcentaje(
                                  totales.totalContado,
                                  totales.totalSolicitudes,
                                )}
                              </td>

                              <td>{totales.totalArrendamiento}</td>
                              <td>
                                {calcularPorcentaje(
                                  totales.totalArrendamiento,
                                  totales.totalSolicitudes,
                                )}
                              </td>

                              <td className="text-green">
                                {totales.totalAutorizadas}
                              </td>
                              <td className="text-green">
                                {calcularPorcentaje(
                                  totales.totalAutorizadas,
                                  totales.totalCredito,
                                )}
                              </td>

                              <td className="text-red">
                                {totales.totalRechazadasCredito}
                              </td>
                              <td className="text-red">
                                {calcularPorcentaje(
                                  totales.totalRechazadasCredito,
                                  totales.totalCredito,
                                )}
                              </td>

                              <td className="text-blue">
                                {totales.totalPendienteBuro}
                              </td>
                              <td className="text-blue">
                                {calcularPorcentaje(
                                  totales.totalPendienteBuro,
                                  totales.totalCredito,
                                )}
                              </td>

                              <td>{totales.totalAnalisis}</td>
                              <td>{totales.totalIncompleto}</td>
                              <td>{totales.totalCondicionadoViable}</td>
                              <td>{totales.totalCondicionadoNoViable}</td>
                              <td>{totales.totalFacturado}</td>
                              <td>{totales.totalFormalizadoCredito}</td>
                              <td>{totales.totalAprobadoSinFormalizar}</td>
                              <td>{totales.totalRechazadoSubstatus}</td>

                              <td>{totales.totalCotizacionContado}</td>
                              <td>{totales.totalFormalizadoContado}</td>

                              <td>{totales.totalCotizacionArrendamiento}</td>
                              <td>
                                {
                                  totales.totalPendienteAutorizacionArrendamiento
                                }
                              </td>
                              <td className="text-green">
                                {totales.totalAutorizadoArrendamiento}
                              </td>
                              <td className="text-green">
                                {calcularPorcentaje(
                                  totales.totalAutorizadoArrendamiento,
                                  totales.totalArrendamiento,
                                )}
                              </td>
                              <td className="text-red">
                                {totales.totalRechazadoArrendamiento}
                              </td>
                              <td className="text-red">
                                {calcularPorcentaje(
                                  totales.totalRechazadoArrendamiento,
                                  totales.totalArrendamiento,
                                )}
                              </td>
                              <td>{totales.totalFormalizadoArrendamiento}</td>

                              <td className="text-green">
                                {totales.totalFormalizados}
                              </td>
                              <td className="text-green">
                                {calcularPorcentaje(
                                  totales.totalFormalizados,
                                  totales.totalSolicitudes,
                                )}
                              </td>

                              <td className="text-red">
                                {totales.totalRechazados}
                              </td>
                              <td className="text-red">
                                {calcularPorcentaje(
                                  totales.totalRechazados,
                                  totales.totalSolicitudes,
                                )}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      ) : (
                        <div
                          className="mailbox-detail-placeholder"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          No hay datos disponibles para mostrar
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreatChart;